export const STUCK_PROCESSING_MS = 30 * 60 * 1000;
export const MAX_BATCH_FILES = 10;
